// extracted by mini-css-extract-plugin
module.exports = {"navigation":"AppBar_navigation__nFgBa","home":"AppBar_home__AJkF0","header":"AppBar_header__3TAEb","register":"AppBar_register__1AYWg"};